import React, { useState, useEffect } from 'react';
import { auth } from '../../firebase'; // Accessing Firebase Auth instance
import BlogFeed from '../../components/BlogFeed'; 
import '../../styles/BlogsPage.css'; // For consistent styling

const CustomerBlogsPage = () => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // This useEffect handles the authentication status check upon component load
    useEffect(() => {
        // Sets up a listener that runs whenever the user's sign-in state changes
        const unsubscribeAuth = auth.onAuthStateChanged((user) => {
            if (user) {
                // User is signed in. Any logged-in user can view published content.
                setCurrentUser(user);
                setError(null);
            } else {
                // User is signed out.
                setCurrentUser(null);
                setError('Please log in to view the Customer Resource Center and access the articles.');
            }
            setLoading(false);
        });

        // Cleanup the listener when the component unmounts
        return () => unsubscribeAuth();
    }, []);

    if (loading) {
        return (
            <div className="blogs-page-container">
                <p>Checking authentication status...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="blogs-page-container">
                <h1 className="blogs-page-header">Customer Resource Center 📚</h1>
                <div className="feed-section">
                    {/* The error-message class is defined in BlogsPage.css */}
                    <p className="error-message">{error}</p>
                </div>
            </div>
        );
    }
    
    // If we reach here, a user is authenticated, and we can display the feed
    return (
        <div className="blogs-page-container">
            <h1 className="blogs-page-header">
                Blogs & Articles 
            </h1>
            
            <div className="feed-section">
                <h2 className="section-title">Latest Nutrition Articles</h2>
                
                {/* isDietitianView={false} forces BlogFeed.js to query: 
                  where('status', '==', 'published').
                */}
                <BlogFeed 
                    isDietitianView={false} 
                />
            </div>

        </div>
    );
};

export default CustomerBlogsPage;
